import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { EmailRoutes } from '@/types/integrations.ts';
import { INTEGRATION_CONFIG_EMAIL_ROUTES_KEY } from '@/utils/queryKeys.ts';
import { get_email_routes_url } from '@/utils/urls.ts';

const useRetrieveEmailRoutes = (
  stepId: string,
  enabled: boolean,
): UseQueryResult<EmailRoutes, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: INTEGRATION_CONFIG_EMAIL_ROUTES_KEY(automationId, stepId),
    queryFn: async () => {
      const response = await apiClient.get<EmailRoutes>(get_email_routes_url(automationId, stepId));
      return response.data;
    },
    enabled: !!automationId && !!stepId && enabled,
  });
};

export default useRetrieveEmailRoutes;
